import { render, staticRenderFns } from "./wutaixingge-simple.vue?vue&type=template&id=61f5ffb4&scoped=true&"
import script from "./wutaixingge-simple.vue?vue&type=script&lang=ts&"
export * from "./wutaixingge-simple.vue?vue&type=script&lang=ts&"
import style0 from "./wutaixingge-simple.vue?vue&type=style&index=0&id=61f5ffb4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f5ffb4",
  null
  
)

export default component.exports